import React, {useCallback, useEffect} from "react";
import {PureButton} from "components/Common";
import styled from "@emotion/styled";
import {useDispatch, useSelector} from "react-redux";
import {getIsMenuOpen} from "modules/selectors/common";
import {toggleMenu} from "modules/actions";
import {getClassAccordingBoolean} from "modules/utils/helpers";
import {useIsMobile} from "modules/utils/hooks";
import menuIcon from "assets/images/menu-icon.svg";

const Button = styled(PureButton)`
	width: 26px;
	height: 26px;
	position: absolute;
	right: 20px;
	top: 20px;
	-webkit-transform: rotate(0deg);
	-moz-transform: rotate(0deg);
	-o-transform: rotate(0deg);
	transform: rotate(0deg);
	-webkit-transition: 0.5s ease-in-out;
	-moz-transition: 0.5s ease-in-out;
	-o-transition: 0.5s ease-in-out;
	transition: 0.5s ease-in-out;
	cursor: pointer;

	img {
		width: 100%;
		height: 100%;
	}
`;

export const BurgerButton: React.FC = () => {
	const {isMobile} = useIsMobile("(max-width: 720px)");
	const dispatch = useDispatch();
	const isOpen = useSelector(getIsMenuOpen);
	const className = getClassAccordingBoolean("open", isOpen);

	useEffect(() => {
		if (!isMobile) {
			dispatch(toggleMenu(false));
		}
	}, [isMobile, dispatch]);

	const toggle = useCallback(() => {
		dispatch(toggleMenu(!isOpen));
	}, [isOpen, dispatch]);

	if (!isMobile) {
		return null;
	}

	return (
		<Button onClick={toggle} className={className}>
			<img src={menuIcon} alt="menu-icon" />
		</Button>
	);
};
